import { useId } from "react";

import styles from "./Loader.module.scss";

export default function Loader({ message = "Cargando..." }) {
  const gradientId = `kitos-loader-${useId().replace(/:/g, "")}`;

  return (
    <div className={styles.loader} role="status" aria-live="polite">
      <svg className={styles.ring} viewBox="0 0 48 48" aria-hidden="true">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#4897d8" />
            <stop offset="100%" stopColor="#fa6e59" />
          </linearGradient>
        </defs>
        <circle className={styles.track} cx="24" cy="24" r="18" />
        <circle
          className={styles.arc}
          cx="24"
          cy="24"
          r="18"
          stroke={`url(#${gradientId})`}
        />
      </svg>
      <p>{message}</p>
    </div>
  );
}
